<template>
  <DocumentEditionPage
      :business="business"
      :client-name="clientName"
      :client-input="isEditable ? clientInput : undefined"
      :number-input="isEditable ? numberInput : undefined"
      :active-category="activeCategory"
      :active-document-number="activeDocumentNumber"
      :is-editable="isEditable"
      :title-input="titleInput"
      :business-elements="businessElements"
      :totals="totals"
      :default-unit-price="defaultUnitPrice"
      :default-tva-percent="defaultTvaPercent"/>
</template>

<script>
import DocumentEditionPage from "@/components/businessEdition/DocumentEditionPage.vue";
import {BUSINESS_DOCUMENT_TYPE_ENUM} from "@/models/businessDocumentTypeEnum";
import {isEditableBusiness} from "@/utils";

export default {
  name: 'QuoteDocument',
  components: {DocumentEditionPage},
  props: {
    business: {type: Object, default: undefined},
    clientName: {type: String, default: ''},
    clientInput: {type: Object, default: undefined},
    numberInput: {type: Object, default: undefined},
    titleInput: {type: Object, required: true},
    businessElements: {type: Array, required: true},
    totals: {type: Object, required: true},
    readOnly: {type: Boolean, default: false},
    defaultUnitPrice: {default: undefined},
    defaultTvaPercent: {default: undefined},
  },
  computed: {
    activeCategory() {
      return BUSINESS_DOCUMENT_TYPE_ENUM.QUOTE.label;
    },
    activeDocumentNumber() {
      return this.business ? this.business.number : '';
    },
    isEditable() {
      return !this.readOnly && isEditableBusiness(this.business);
    },
  },
};
</script>